export function fixScrollbars(Swiper, modules, query = document.querySelectorAll('.scrollbar')) {
    query.forEach(scrollbar => {
        let dataOptions = {};
        try { dataOptions = JSON.parse(scrollbar.dataset.options || '{}'); } catch (e) {}
        const autoplayInterval = parseInt(dataOptions.autoplay_interval) || 5000;
        const effInterval = parseInt(dataOptions.eff_interval) || 300;

        if (scrollbar.swiper) scrollbar.swiper.destroy(true, true);

        // Restore original slide order (loopFix moves slides in the DOM)
        const wrapper = scrollbar.querySelector('.swiper-wrapper');
        if (wrapper) {
            const slides = [...wrapper.querySelectorAll('.swiper-slide')];
            slides
                .sort((a, b) => parseInt(a.dataset.swiperSlideIndex || 0) - parseInt(b.dataset.swiperSlideIndex || 0))
                .forEach(slide => wrapper.appendChild(slide));
        }

        const count = scrollbar.querySelectorAll('.swiper-slide').length;

        new Swiper(scrollbar, {
            modules,
            watchOverflow: false,
            loop: false,
            rewind: true,
            speed: effInterval,
            spaceBetween: 10,
            autoplay: { delay: autoplayInterval, disableOnInteraction: false },
            navigation: {
                nextEl: scrollbar.querySelector('.swiper-button-next'),
                prevEl: scrollbar.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                0: { slidesPerView: 3, autoplay: { enabled: count > 3 } },
                768: { slidesPerView: 4, autoplay: { enabled: count > 4 } },
                1024: { slidesPerView: 5, autoplay: { enabled: count > 5 } },
            },
        });
    });
}
